/**
 * Created by jv on 30/05/2018.
 */
const ATLAS_KEY = "carrot-game-atlas";

export default {
  DEBUG: false,

  ATLAS_KEY,

  OBSTACLES: [ "obstacles/obstacle_bucket.png", "obstacles/obstacle_fence.png", "obstacles/obstacle_hay-bale.png", "obstacles/obstacle_manger.png", "obstacles/obstacle_milk-jug.png", "obstacles/obstacle_mudpool.png", "obstacles/obstacle_watering-can.png" ],
  POWER_UPS: [
    // { key: ATLAS_KEY, frame: "power-ups/powerup_bounce-ball.png", type: "springball", duration: 15 * 1000 },
    { key: ATLAS_KEY, frame: "power-ups/powerup_magnet.png", activeTexture: { key: ATLAS_KEY, frame: "power-ups/powerup_magnet-active.png", offset: { x: 0, y: 0 } }, type: "magnet", duration: 18 * 1000 },
    { key: ATLAS_KEY, frame: "power-ups/powerup_rocket-cake.png", type: "rocket-cake", duration: 15 * 1000 },
    { key: ATLAS_KEY, frame: "power-ups/powerup_shield.png", activeTexture: { key: ATLAS_KEY, frame: "power-ups/powerup_shield-active.png", offset: { x: 75, y: 30 } }, type: "shield", duration: 18 * 1000 }
  ]
}



// WEBPACK FOOTER //
// ./app/js/games/carrot-game/config/constants.js